import { createFileRoute } from "@tanstack/react-router";

import Organisations from "~/pages/Administration/Organisations";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/administration/")({
  staticData: ROUTE_STATIC.administration,
  component: Organisations,
});
